const Diamond: React.FC<{
  className?: string;
}> = ({ className = '' }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.0098 12.5L12 23.5098L0.990234 12.5L12 1.49023L23.0098 12.5Z"
        stroke="#FFFCB6"
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default Diamond;
